import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import dayjs from 'dayjs';

class EquipementStatsService {
    public async getNonPreventiveInterventionStatsByPhase(id: number): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetNonPreventiveInterventionStatsByPhase(id, '12'));
    }

    public async getPreventiveInterventionStatsByPhasePeriod(id: number): Promise<any> {
        const dateFinMois = dayjs().endOf('month');
        const dateDebutCircleData = dateFinMois.set('month', dateFinMois.get('month') - 11).startOf('month');

        return http.get(
            Routes.InterventionRoutes.GetPreventiveInterventionStatsByPhase(
                id,
                dateDebutCircleData.format('YYYY-MM-DD'),
                dateFinMois.format('YYYY-MM-DD')
            )
        );
    }

    public async getPreventiveInterventionStatsByMonth(id: number): Promise<any> {
        const today = dayjs();
        const dateDebut = dayjs()
            .set('month', today.get('month') - 5)
            .startOf('month');

        const dateFin = dayjs()
            .set('month', today.get('month') + 6)
            .endOf('month');

        return http.get(
            Routes.InterventionRoutes.GetPreventiveInterventionStatsMonthByPhase(
                id,
                dateDebut.format('YYYY-MM-DD'),
                dateFin.format('YYYY-MM-DD')
            )
        );
    }

    public async getDevisStatsByPhase(id: number): Promise<any> {
        return http.get(Routes.EstimateRoutes.GetDevisStatsByPhase(id));
    }

    public async getDemandesInterventionStatsByPhase(id: number): Promise<any> {
        return http.get(Routes.DemandeInterventionRoutes.GetDemandesInterventionStatsByPhase(id, '12'));
    }
}

export default new EquipementStatsService();
